import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import ReservationForm from '../components/reservationForm';
import ChristmasNotification from '../components/notifications/christmasNotification';
const Reserveren = (props) => (
    <div>
        <Helmet
            title="Huur nu een photobooth v.a. €195 all in"
            meta={[
                {
                    name: 'description',
                    content: `Huur binnen 5 minuten een photbooth voor jouw evenement, trouwerij, bedrijfsborrel, jubileumfeest of ander feestje waar veel plezier gemaakt mag worden! All in prijzen vanaf €195,- per 24 uur! `
                },
                {
                    name: 'keywords',
                    content: [
                        'photobooth', 'videobooth', 'gifbooth', 'fotobooth',
                        'fotohokje', 'bruiloft', 'gif photobooth', 'huren',
                        'lenen', 'trouwerij', 'evenement', 'feest', 'bedrijfsfeest',
                        'borrel', 'beurzen', 'beurs', 'verhuur'
                    ].join(',')
                },
            ]}
        />
        <div className="hero is-primary">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <h1 className="title">Reserveer een photobooth voor jouw feest of evenement</h1>
                </div>
            </div>
        </div>
        <ReservationForm />
    </div>
);

export default Reserveren;



// WEBPACK FOOTER //
// ./src/pages/reserveren.js